import React from "react";
import styles from "./SectionWrapper.module.css";

const SectionWrapper = ({ title, subtitle, children, bg = "white" }) => {
  return (
    <section className={`${styles.section} ${styles[bg]}`}>
      <div className="container">
        {(title || subtitle) && (
          <div className={styles.header}>
            {title && <h2 className={styles.title}>{title}</h2>}
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
          </div>
        )}
        {children}
      </div>
    </section>
  );
};

export default SectionWrapper;
